import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import { PUBLIC_URL } from "../../../../../utils/axiosConfig";

function InstitutionInfo({ institution }) {
  return (
    <MDBox>
      <MDBox mb={1}>
        <MDTypography variant="h3" fontWeight="bold">
          {institution.name}
        </MDTypography>
        {institution.logo && (
          <MDBox
            component="img"
            src={`${PUBLIC_URL}/${institution.logo}`}
            alt="Logo"
            width="100px"
            position="absolute"
            top="1.5rem"
            right="1.5rem"
          />
        )}
      </MDBox>

      <MDBox mt={3} mb={1} ml={0.5}>
        <MDTypography variant="button" fontWeight="regular" color="text">
          Descripción
        </MDTypography>
      </MDBox>
      <MDBox component="ul" m={0} pl={4} mb={2}>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            {institution.description}
          </MDTypography>
        </MDBox>
        <MDBox component="li" color="text" fontSize="1.25rem" lineHeight={1}>
          <MDTypography variant="body2" color="text" fontWeight="regular" verticalAlign="middle">
            Sitio web: {institution.website}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

InstitutionInfo.propTypes = {
  institution: PropTypes.object.isRequired,
};

export default InstitutionInfo;
